<template>
	<div class="app-container gamesIndex">
		<el-card>
			<div slot="header" class="clearfix">
				<h3 class="pageName">{{pageName}}</h3>
			</div>

			<!-- <el-button type="primary" icon="el-icon-plus" @click="handleAdd" class="mb20">添加模板分类</el-button> -->
			<el-table v-loading="loading" element-loading-text="加载中" :data="list">
				<el-table-column label="序号" align="center" type="index" width="50" />
				<el-table-column label="分类名称" align="center" prop="fileTypeName" />
				<el-table-column label="发布人员" align="center" prop="createBy" />
				<el-table-column label="发布时间" align="center" prop="updateTime"></el-table-column>
				<!-- <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
					<template slot-scope="scope">
						<el-button size="small" plain type="primary" @click="handleEdit(scope.row)">编辑</el-button>
						<el-button size="small" plain type="danger" @click="handleDel(scope.row)">删除</el-button>
					</template>
				</el-table-column> -->
			</el-table>

			<pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNum"
				:limit.sync="queryParams.pageSize" @pagination="_getList" />
		</el-card>
		<el-dialog :title="dialogTit" :visible.sync="dialogShow" width="600px" append-to-body>
			<el-form ref="setform" :model="setParams" size="mini" :rules="rules">
				<el-form-item label="模板分类名称" prop="fileTypeName">
					<el-input clearable size="small" style="width: 400px" placeholder="请输入模板分类名称"
						v-model="setParams.fileTypeName" />
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submitForm">确 定</el-button>
				<el-button @click="dialogShow = false">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import * as API_File from "@/api/sportManage/file";

	export default {
		name: "gamesIndex",
		components: {
			// baseTab,portTab,wechatTab,inviteTab
		},
		data() {
			return {
				pageName: '模板分类',
				queryParams: {},
				list: [],
				total: 0,
				loading: false,
				dialogTit: "编辑赛事类型",
				setParams: {},
				rules: {},
				dialogShow: false,
				actions: '',
				rules: {
					fileTypeName: [{
						required: true,
						message: "请输入模块分类名称",
						trigger: "blur"
					}, ]
				}
			};
		},
		created() {
			this._getList()
		},
		methods: {
			resetQuery() {
				this.$refs["queryForm"].resetFields();
				this.queryParams.startTime = ''
				this.queryParams.endTime = ''
				this._getList();
			},
			handleAdd() {
				this.setParams = {}
				this.actions = 'add'
				this.dialogShow = true
				this.dialogTit = '添加模块分类'
			},
			_getList() {
				API_File.fileItemList(this.queryParams).then((res) => {
					this.list = res.data.list
				}).catch((err) => {

				});

			},
			handleList(row) {

			},
			handleEdit(row) {
				this.actions = 'edit'
				this.setParams = JSON.parse(JSON.stringify(row));
				this.dialogShow = true
			},
			//删除模板提示
			handleDel(row) {
				this.$confirm(`确定删除模板分类"${row.fileTypeName}"?`, "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(() => {
						console.log(row)
						this._delType(row)
					})
					.catch(() => {});
			},
			submitForm() {
				this.$refs['setform'].validate((valid) => {
					if (valid) {
						console.log(this.actions)
						this.actions == 'add' ? this._addType() : this._editType()
					} else {
						console.log('error submit!!');
						this.$message({
							message: '填写数据不全或数据有误',
							type: 'error'
						});
						return false;
					}
				});
			},
			//接口 新增模板分类
			_addType() {
				API_File.addType(this.setParams).then((res) => {
					this.$message({
						message: '新增成功',
						type: 'success'
					})
					this._getList();
					this.dialogShow = false
				}).catch((err) => {})
			},
			//接口-修改模板分类
			_editType() {
				API_File.editType(this.setParams).then((res) => {
					this.$message({
						message: '编辑成功',
						type: 'success'
					})
					this._getList();
					this.dialogShow = false
				}).catch((err) => {})
			},
			//接口-删除模板分类
			_delType(row) {
				API_File.delType({
					id: row.id
				}).then((res) => {
					this.$message({
						message: "删除成功",
					});
					this._getList()
				})
			}
		},
	};
</script>

<style lang="scss">
	.gamesIndex {
		padding: 40px 40px;
		color: #676a6c;
		font-size: 13px;
		font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
		overflow-x: hidden;

	}
</style>


<style lang="scss">
	@import "../../../assets/styles/common.scss";
</style>